import { client } from '../client';
import { IOneReport } from './types/IOneReport';
import { IOneReportMedia } from './types/IOneReportMedia';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const updateOneReportMedia = async (
  one_report_id: string,
  one_report_media_id: string,
  payload: IOneReportMedia,
  userRole?: string,
): Promise<IOneReport> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch<IOneReport>(
    `${prefix}/one_reports/${one_report_id}/media/${one_report_media_id}`,
    payload,
  );

  return data;
};
